import NewsletterForm from '~/themes/base/components/shop/NewsletterForm'

export default {
  extends: NewsletterForm,
}
